export class Team {
    id: number;
    leagueId: number;
    country: string;
    description: string;
    name: string;
    teamId: number;
}



// WEBPACK FOOTER //
// ./src/app/shared/team.model.ts